module.exports = __webpack_public_path__ + "assets/img/quotation.49bd18ae.svg";